<template>
  <section class="section">
    <div class="section-image" :class="{ '-reverse': reverse }">
      <div>
        <h2 class="section__title" v-reveal>{{ title }}</h2>
        <div class="section__subtitle" v-if="subtitle" v-reveal="{ delay: 200 }">
          {{ subtitle }}
        </div>
        <div class="section-image__content" v-html="content" v-reveal="{ delay: 250 }" />
        <div v-if="hydro" class="section-image__hydro" v-reveal>
          <b> Évènement propulsé par </b>
          <img src="/images/HydroQuebec.svg" alt="Hydro-Québec" width="200" height="100" />
        </div>
      </div>

      <img
        class="section-image__image"
        :class="{ '-big': hydro }"
        :src="image"
        alt="image"
        v-reveal="{ delay: 300 }"
      />
    </div>
  </section>
</template>

<script>
export default {
  name: 'SectionImage',
  props: {
    hydro: {
      type: Boolean,
      default: false,
    },
    reverse: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: 'Title',
    },
    subtitle: {
      type: String,
      default: null,
    },
    content: {
      type: String,
      default: 'content',
    },
    image: {
      type: String,
      default: 'https://placehold.co/400x500',
    },
  },
}
</script>
